var map = {
	"./1.svg": "5d75",
	"./2.svg": "ac90",
	"./3.svg": "f0f7",
	"./4.svg": "f0c5",
	"./delete.svg": "216b",
	"./download.svg": "9615",
	"./edit.svg": "ef3b",
	"./eye.svg": "afd8",
	"./up.svg": "d3d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32f9";